import { makeStyles } from 'src/utils/makeStyles';

export default makeStyles({
  wrapper: {
    padding: { tablet: '33px 40px 40px' },
    width: { chat: '800px' },
    minHeight: '300px',
  },
  titleWrapper: {
    boxShadow: 'inset 0px -1px 0px rgba(97, 148, 185, 0.25)',
    paddingBottom: '12px',
  },
  disclaimer: {
    color: 'orange5',
    cursor: 'pointer',
    ':hover': { textDecoration: 'underline' },
    fontSize: 13,
  },
  list: {
    marginTop: '40px',
  },
  addButton: {
    '& svg': {
      fill: 'currentColor',
    },
  },
  buttons: {
    marginTop: '40px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
  loaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginY: 5,
  },
});
